import { useState, useCallback } from "react";
import {
  Box,
  Typography,
  Stack,
  Alert,
  AlertTitle,
} from "@mui/material";
import { PlatformPage } from "@tracabois/template";
import { useCsvImportUploadMutation, CsvDropzone, CsvTemplateDownload } from "@tracabois/domain";
import { useNavigate } from "react-router-dom";

export const CsvImportPage = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [uploadCsv, { isLoading: isUploading }] = useCsvImportUploadMutation();

  const handleFileSelected = useCallback(
    async (file: File, base64Content: string) => {
      setError(null);
      try {
        const result = await uploadCsv({
          fileName: file.name,
          fileContentBase64: base64Content,
        } as any).unwrap();

        navigate(`/csv/import/${result.importId}`);
      } catch (err: any) {
        setError(err?.data?.message || "Erreur lors de l'analyse du fichier");
      }
    },
    [uploadCsv, navigate]
  );

  return (
    <PlatformPage title="Import CSV - Bâtiments Bois des Alpes">
      <Stack spacing={3}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="body2" color="text.secondary">
            Importez des bâtiments certifiés Bois des Alpes depuis un fichier CSV.
          </Typography>
          <CsvTemplateDownload />
        </Box>

        {error && (
          <Alert severity="error" onClose={() => setError(null)}>
            <AlertTitle>Erreur</AlertTitle>
            {error}
          </Alert>
        )}

        <CsvDropzone
          onFileSelected={handleFileSelected}
          isLoading={isUploading}
          disabled={false}
        />
      </Stack>
    </PlatformPage>
  );
};
